
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 25 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.38","d":"m17.602 8.73 1.234-1.091M18.146 6.998l1.33 1.112M12.5 7.389V4.49m0 0h1.89m-1.89 0h-1.889"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":"1.38","d":"M12.5 7.383a9.19 9.19 0 1 1 0 18.381 9.19 9.19 0 0 1 0-18.381Z"}}),_c('path',{attrs:{"fill":"#D1ED7E","d":"M12.5 9.326a7.253 7.253 0 1 1-6.53 10.409l6.53-3.156z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.38","d":"m12.5 16.416-6.084 3.042"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":"1.311","d":"M12.496 15.854a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3Z"}})])
          )
        }
      }
    